import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const PageContainer = styled.div`
  ${tw`p-4 bg-bg-secondary min-h-screen max-w-full min-w-0 box-border`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-6 max-w-screen-xl mx-auto`}
`;

const TabContainer = styled.div`
  ${tw`flex mb-6 justify-center`}
  background-color: var(--color-border);
  padding: 2px;
  width: fit-content;
  margin: 0 auto;
`;

const TabSkeleton = styled(Skeleton)`
  ${tw`px-8 py-2 text-sm font-medium mx-px`}
  width: 120px;
  height: 36px;
`;

const BookingList = styled.div`
  ${tw`space-y-4 max-w-screen-xl mx-auto px-4 md:px-8 lg:px-0`}
`;

const BookingCard = styled.div`
  ${tw`bg-white rounded-lg shadow-card`}
`;

const BookingHeader = styled.div`
  ${tw`p-4 border-b border-border-default`}
`;

const StatusSkeleton = styled(Skeleton)`
  ${tw`h-6 w-24 rounded-full`}
`;

const BookingBody = styled.div`
  ${tw`p-4`}
`;

const DateRangeSkeleton = styled(Skeleton)`
  ${tw`h-4 w-64 mb-2`}
`;

const CarInfo = styled.div`
  ${tw`flex items-center gap-4`}
`;

const CarImageSkeleton = styled(Skeleton)`
  ${tw`w-20 h-16 rounded-md`}
`;

const CarDetails = styled.div`
  ${tw`flex-1`}
`;

const CarNameSkeleton = styled(Skeleton)`
  ${tw`h-6 w-48 mb-2`}
`;

const LocationSkeleton = styled(Skeleton)`
  ${tw`h-4 w-full max-w-md mb-1`}
`;

const HostInfo = styled.div`
  ${tw`mt-3 pt-3 border-t border-border-default`}
`;

const HostInfoSkeleton = styled(Skeleton)`
  ${tw`h-4 w-32 mt-3`}
`;

const MyBookingsPageSkeleton: React.FC = () => {
  return (
    <PageContainer>
      <TitleSkeleton />

      <TabContainer>
        <TabSkeleton />
        <TabSkeleton />
        <TabSkeleton />
      </TabContainer>

      <BookingList>
        {Array(3)
          .fill(0)
          .map((_, index) => (
            <BookingCard key={index}>
              <BookingHeader>
                <StatusSkeleton />
              </BookingHeader>
              <BookingBody>
                <DateRangeSkeleton />
                <CarInfo>
                  <CarImageSkeleton />
                  <CarDetails>
                    <CarNameSkeleton />
                    <LocationSkeleton />
                    <LocationSkeleton width="90%" />
                    <HostInfo>
                      <HostInfoSkeleton />
                    </HostInfo>
                  </CarDetails>
                </CarInfo>
              </BookingBody>
            </BookingCard>
          ))}
      </BookingList>
    </PageContainer>
  );
};

export default MyBookingsPageSkeleton;
